import React from 'react';
import Table from 'react-bootstrap/Table';
import {
  formatFieldDisplayValue,
  getFieldLabel,
} from '../../utils/productEnrichment';

/**
 * Read-only field_diffs context (applications, catalog_number, etc.).
 *
 * @param {Object} props
 * @param {Array<[string, Object]>} props.entries - from getReadOnlyFieldDiffEntries
 */
const ProductEnrichmentReadOnlyDiffTable = ({ entries }) => {
  if (!entries?.length) {
    return null;
  }

  return (
    <div className="mt-4">
      <h6 className="fw-semibold mb-2">Read-only context</h6>
      <Table bordered responsive size="sm" className="mb-0">
        <thead>
          <tr>
            <th>Field</th>
            <th>Current</th>
            <th>Suggested</th>
          </tr>
        </thead>
        <tbody>
          {entries.map(([fieldKey, diff]) => {
            const isImageField = fieldKey === 'image_url';
            return (
              <tr key={fieldKey}>
                <td>{getFieldLabel(fieldKey, diff)}</td>
                <td>{formatFieldDisplayValue(diff?.current)}</td>
                <td>
                  {isImageField && diff?.suggested ? (
                    <div>
                      <a
                        href={String(diff.suggested)}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Preview
                      </a>
                      <div className="mt-1">
                        <img
                          src={diff.suggested}
                          alt="Suggested product"
                          style={{
                            maxWidth: 120,
                            maxHeight: 80,
                            objectFit: 'contain',
                          }}
                          onError={e => {
                            e.target.style.display = 'none';
                          }}
                        />
                      </div>
                    </div>
                  ) : (
                    formatFieldDisplayValue(diff?.suggested)
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
};

export default ProductEnrichmentReadOnlyDiffTable;
